import React from 'react';

import "../../assets/css/MainContainer.css";

const MainContainer = ({ children }) => {
  return (
    <div className='MainContainer'>
      {children}
    </div>
  );
};

export default MainContainer;